import FilterCheckboxChip from './FilterCheckboxChip';
import FilterSelect from '../Input/FilterSelect';
import { formatVolume } from 'utils/helpers';
import { handleMixpanelEvent } from '../FilterAccordion/FilterAccordionItem';
import styled from 'styled-components';
import { useFetchMostPopularInstagramAffinityRoots } from 'utils/hooks/useInstagramRelatedHashtagData.hook';
import { withMixpanelChange } from 'utils/app';

const Wrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space_6}px;
`;

const InstagramAffinityFilterChipsUntracked = ({
    menus,
    filtersSansHealthStats,
    filters,
    setFilter,
    setFilters,
    filterNames,
    mixpanelMeta,
    getOnChange,
    appliedFilters,
    onChange,
    queryData,
    ...props
}) => {
    const { data, ...restQuery } =
        useFetchMostPopularInstagramAffinityRoots(queryData);
    const isLoading = restQuery.isIdle || restQuery.isLoading;
    const resetMenuFilters = () => {
        const instagramParentName = (filters.instagramParentName || []).filter(
            ({ value }) => data?.some((option) => option.value === value),
        );
        const nextFilters = {};

        if (instagramParentName.length) {
            nextFilters.instagramParentName = instagramParentName;
        }

        setFilters(nextFilters);
    };
    return (
        <Wrapper {...props}>
            {menus && menus.length ? (
                <span id="data-table-filter-select">
                    <FilterSelect
                        filters={filtersSansHealthStats}
                        setFilter={setFilter}
                        resetFilters={resetMenuFilters}
                        mixpanelMeta={mixpanelMeta}
                        menus={menus}
                        getOnChange={getOnChange}
                        menuAlign="left"
                        queryData={queryData}
                        appliedFilterChipCount={data?.reduce(
                            (acc, { value }) =>
                                acc + (appliedFilters?.includes(value) ? 1 : 0),
                            0,
                        )}
                    />
                </span>
            ) : null}
            {isLoading ? (
                <FilterCheckboxChip
                    disabled={true}
                    checked={false}
                    isLoading={isLoading}
                />
            ) : null}
            {data?.map((option) => {
                const { label, value, volume } = option;
                const checked =
                    !!appliedFilters && appliedFilters.includes(value);
                return (
                    <FilterCheckboxChip
                        checked={checked}
                        onChange={() =>
                            onChange({
                                action: checked
                                    ? 'remove-value'
                                    : 'select-option',
                                option,
                            })
                        }
                        preserveIconSpace={false}
                        key={label}
                    >
                        <span>
                            {label}{' '}
                            <span
                                css={`
                                    font-weight: 500;
                                    margin-left: 0.5rem;
                                    color: ${({ theme }) => theme.gray_600};
                                    text-transform: uppercase;
                                `}
                            >
                                {formatVolume(volume)}
                            </span>
                        </span>
                    </FilterCheckboxChip>
                );
            })}
        </Wrapper>
    );
};

const InstagramAffinityFilterChipsWithMixpanel = withMixpanelChange(
    InstagramAffinityFilterChipsUntracked,
    'InstagramAffinityFilterChips',
);

export const InstagramAffinityFilterChips = ({
    handleMixpanelEvent: handleMixpanelEventProp = handleMixpanelEvent,
    mixpanelContext = 'InstagramGroupFilterSelect',
    ...props
}) => {
    return (
        <InstagramAffinityFilterChipsWithMixpanel
            handleMixpanelEvent={handleMixpanelEventProp}
            mixpanelContext={mixpanelContext}
            {...props}
        />
    );
};

export default InstagramAffinityFilterChips;
